import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/services/event.service';
@Component({
  selector: 'app-buy-with',
  templateUrl: './buy-with.component.html',
  styleUrls: ['./buy-with.component.scss'],
})
export class BuyWithComponent implements OnInit {
  lang: any = localStorage.getItem('currentlang');
  items = [
    {
      img: './assets/images/new/card-icon.svg',
      head: 'buy_card',
      head_mob: 'buy_with_card ',
    },
    {
      img: './assets/images/new/exchange-icon.svg',
      head: 'buy_exchange',
      head_mob: 'buy_exchange',
    },
    {
      img: './assets/images/new/lock-icon.svg',
      head: 'buy_secure',
      head_mob: 'buy_secure',
    },
  ];
  constructor(private eventService: EventService) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
  }
  get isBsc() {
    return this.eventService.isBsc;
  }
  ngOnInit(): void {}
}
